// user
import { useEffect, useState } from "react";

import WebbDividerMedium from "../webx/webb-divider-md";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { Form, Row, Col, Input } from 'antd';


export default function NetworkListModule() {

  const asset = GetUserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();
  const form = GetUserForm();
  const indx = GetLocalUser();
  const bznx = GetLocalBusiness();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
    
  const onFinish = async (values) => {

  }
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
    <div 
      className='rounded back-color-wite' 
      style={{position:'absolute', height:'79vh', top:10, bottom:0, width: '100%'}}>
      
      <Row>
        <Col span={6} className='border back-color-lite' style={{height:'79vh'}}>
          <div className="m-2">
            <p className="text-bold m-0">Network List</p>
          </div>
          <div className="border-bottom"></div>
          <div 
            className="" 
            style={{position:'relative', height:'71vh', overflowY:'auto'}}>
            
            <div className="hilite cursor">
              <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
              <p className="m-0 mx-2 py-1">Room X</p>
            </div>

            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
            <div className="hilite cursor">
            <p className="m-0 mx-2 py-1">Room X</p>
            </div>
          </div>

        </Col>
        <Col span={18} className='border back-color-wite' style={{height:'79vh'}}>
        
          <div className="m-2">
            <p className="text-bold m-0">Room Name</p>
          </div>
          <div className="border-bottom"></div>
          <div 
            className="" 
            style={{position:'relative', height:'66vh', overflowY:'auto'}}>


            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>

            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>

            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>

            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>

            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>                                    

            <div className="mb-3">
              <p className="m-0 mx-2 text-color-tone">username * 09.33</p>
              <p className="m-0 mx-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>

          </div>

          <div 
            className="border-top" 
            style={{position:'relative', height:'6vh'}}>

<Form
        name="auth"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
      <Form.Item
        name="username"
        rules={[{ required: true, message: 'Please enter your message!' }]}
      >
        <Input placeholder="enter message" className="border-none" height={'100%'}/>
      </Form.Item>
      </Form>
          </div>

        </Col>
      </Row>

    </div>


    </>
  );

}

// http://jsfiddle.net/milanandfriends/4YxfL/
// https://stackoverflow.com/questions/18934141/set-div-height-to-fit-to-the-browser-using-css